import { Reducer } from 'redux';
import { DeliveryEventsType, InitialDeliveryEvents } from './types';

const INITIAL_STATE: InitialDeliveryEvents[] = [];

const reducer: Reducer<InitialDeliveryEvents[]> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case DeliveryEventsType.GET_DELIVERY_EVENTS:
      return action.payload;

    default:
      return state;
  }
};

export default reducer;
